import fetch from 'commons/src/api/fetch';
import getFetchHeaders from 'commons/src/api/getFetchHeaders';
import {
    FetchIaqInsightDataType,
    FetchIaqInsightDataV2Type,
    FetchVirusRiskInsightDataType,
    IaqInsightResponse,
    RadonInsightResponse,
    VirusRiskInsightResponse,
} from '../actions/insightActions';

type ReportPayload = { from: string; to: string; serialNumbers: string[]; locationId: string };

export default async (payload: ReportPayload): Promise<RadonInsightResponse> =>
    fetch(`/locations/${payload.locationId}/reports/radon`, {
        method: 'POST',
        headers: await getFetchHeaders(),
        body: JSON.stringify(payload),
    });

export const getIaqReport = async (payload: FetchIaqInsightDataType): Promise<IaqInsightResponse> =>
    fetch(`/locations/${payload.locationId}/reports/iaq`, {
        method: 'POST',
        headers: await getFetchHeaders(),
        body: JSON.stringify(payload),
    });

// Used by iaqInsight2 feature: API call to v2 endpoint which supports space-based filtering and returns data in v2 format
export const getIaqReportV2 = async (payload: FetchIaqInsightDataV2Type): Promise<IaqInsightResponse> => {
    const url = `/locations/${payload.locationId}/reports/iaq/v2`;

    // Map 'noise' to 'sla' for backend API compatibility
    // The frontend uses 'noise' for user clarity, but the backend expects 'sla' (Sound Level Average)
    const mappedSensors = payload.sensors.map(sensor => (sensor === 'noise' ? 'sla' : sensor));

    const requestBody = JSON.stringify({
        ...payload,
        sensors: mappedSensors,
    });

    return fetch(url, {
        method: 'POST',
        headers: await getFetchHeaders(),
        body: requestBody,
    });
};

export const getVirusRiskReport = async (payload: FetchVirusRiskInsightDataType): Promise<VirusRiskInsightResponse> =>
    fetch(`/locations/${payload.locationId}/reports/virus`, {
        method: 'POST',
        headers: await getFetchHeaders(),
        body: JSON.stringify(payload),
    });
